import { gql } from "@apollo/client";

export const GENERATE_RENTAL_AGREEMENT_PDF = gql`
  mutation generateRentalAgreementPdf($id: String!) {
    generateRentalAgreementPdf(id: $id){
      success
      message
    }
  }
`;